export const langText = {
    en: {
        doc: 'Documentation',
        manual: 'Manuals',
        media: 'Media',
        compliance: 'Compliance',
        software: 'Software',
        all: 'All',
        operation: 'Operation',
        troubleshooting: 'Troubleshooting',
        related: 'Other Related',
    },
    cn: {
        doc: '资料',
        manual: '产品手册',
        media: '多媒体',
        compliance: '合规文件',
        software: '软件',
        all: '全部',
        operation: '产品使用',
        troubleshooting: '故障处理',
        related: '其他相关文档',
    },
    de: {
        doc: 'Dokumentationen',
        manual: 'Handbücher',
        media: 'Medien',
        compliance: 'Konformität',
        software: 'Software',
        all: 'Alle',
        operation: 'Bedienung',
        troubleshooting: 'Fehlerbehebung',
        related: 'Weitere zugehörige Dokumente',
    },
    fr: {
        doc: 'Documentation',
        manual: 'Manuels',
        media: 'Médias',
        compliance: 'Conformité',
        software: 'Logiciel',
        all: 'Tout',
        operation: 'Fonctionnement du produit',
        troubleshooting: 'Dépannage',
        related: 'Autres documents connexes',
    },
    it: {
        doc: 'Documentazione',
        manual: 'Manuali',
        media: 'Media',
        compliance: 'Conformità',
        software: 'Software',
        all: 'Tutto',
        operation: 'Funzionamento del prodotto',
        troubleshooting: 'Risoluzione dei problemi',
        related: 'Altri documenti correlati',
    },
    es: {
        doc: 'Documentación',
        manual: 'Manuales',
        media: 'Medios',
        compliance: 'Conformidad',
        software: 'Software',
        all: 'Todo',
        operation: 'Operación del producto',
        troubleshooting: 'Solución de problemas',
        related: 'Otros documentos relacionados',
    },
    jp: {
        doc: 'ドキュメント',
        manual: 'マニュアル',
        media: 'メディア',
        compliance: 'コンプライアンス',
        software: 'ソフトウェア',
        all: 'すべて',
        operation: '製品の操作',
        troubleshooting: 'トラブルシューティング',
        related: 'その他関連文書',
    },
    kr: {
        doc: '문서',
        manual: '매뉴얼',
        media: '미디어',
        compliance: '준수 문서',
        software: '소프트웨어',
        all: '모두',
        operation: '제품 운영',
        troubleshooting: '문제 해결',
        related: '기타 관련 문서',
    },
    sa: {
        doc: 'الوثائق ',
        manual: 'أدلة الاستخدام',
        media: 'الوسائط',
        compliance: 'وثائق الامتثال',
        software: 'برمجة',
        all: ' الكل',
        operation: 'تشغيل المنتج',
        troubleshooting: 'استكشاف المشكلات وإصلاحها',
        related: 'مستندات أخرى ذات صلة',
    },
    tw: {
        doc: '文件',
        manual: '使用手冊',
        media: '媒體',
        compliance: '合規文件',
        software: '軟體',
        all: '全部',
        operation: '產品操作',
        troubleshooting: '疑難排解',
        related: '其他相關文件',
    },
    br: {
        doc: 'Documentação',
        manual: 'Manuais',
        media: 'Mídia',
        compliance: 'Conformidade',
        software: 'Programas',
        all: 'Todos',
        operation: 'Funcionamento',
        troubleshooting: 'Resolução de problemas',
        related: 'Outros',
    },
    mx: {
        doc: 'Documentación',
        manual: 'Manuales',
        media: 'Medios',
        compliance: 'Conformidad',
        software: 'Software',
        all: 'Todo',
        operation: 'Operación del producto',
        troubleshooting: 'Solución de problemas',
        related: 'Otros documentos relacionados',
    },
    ph: {
        doc: 'Documentation',
        manual: 'Manuals',
        media: 'Media',
        compliance: 'Compliance',
        software: 'Software',
        all: 'All',
        operation: 'Operation',
        troubleshooting: 'Troubleshooting',
        related: 'Other Related',
    },
    nl: {
        doc: 'Documentatie',
        manual: 'Handleidingen',
        media: 'Media',
        compliance: 'naleving',
        software: 'Software',
        all: 'alle',
        operation: 'operatie',
        troubleshooting: 'probleemoplossing',
        related: 'verwant',
    },
};
